export const toDoType = {
  standalone: 'standalone',
  onlineTest: 'online-test',
  assessment: 'assessment',
  evaluation: 'evaluation',
  eEvaluation: 'e-evaluation',
  eTesting: 'e-testing',
}
